import router from "@/router"

export function goToLogin() {
  router.push({ name: "Login" })
}

export function goToReserva(paseClaseId = null) {
  if (paseClaseId) {
    router.push({
      name: "ReservaPase",
      params: { paseClaseId: paseClaseId, another: "hola" },
    })
  } else {
    router.push({ name: "ReservaPase" })
  }
}

export function goToDashboard() {
  router.push({ name: "Dashboard" })
}

export function getRouterPaseClaseId() {
  // TODO: ojo aca, si retorno sólo uno o que
  const paseClaseId = router.currentRoute._value?.params?.paseClaseId ?? null
  return paseClaseId
}

export function getRouterToken() {
  const token = router.currentRoute._value?.params?.token ?? null
  return token
}
